// extracted by mini-css-extract-plugin
export var gif = "_l7-0";